import React, { useCallback, useEffect, useMemo } from 'react'
import { useState } from 'react'
import Toolbar, { Item } from 'devextreme-react/toolbar'
import { SettingType } from 'helpers/setting-type-enum'
import { settingsMenuSelector } from 'slices/ui'
import { RootState } from 'slices'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'

import { useUserSettingsUpdate } from 'hooks'

import './form-group.scss'


export const FormGroup = ({name, caption, style=undefined, formId='', id=null, onMoveDown, onMoveUp, orderMap=[], ...props}: any) => {
    const [expanded, setExpanded] = useState(true)
    const dispatch = useAppDispatch()
    const [firstRender, setFirstRender] = useState(true)

    const setExpandedFormGroupsData = useUserSettingsUpdate()

    const index = useMemo(() => (orderMap.indexOf(id)),[orderMap, id])
    const {value: expandedFormGroups, id: expandedFormGroupsId} = useSelector((state: RootState) => settingsMenuSelector(state, formId))

    useEffect(() => {
        if (formId && firstRender) {
            setFirstRender(false)
            
            if (expandedFormGroups && Object.hasOwn(expandedFormGroups, id)) {
                setExpanded(expandedFormGroups[id])
            }
        }

    },[expandedFormGroups, firstRender, formId, id, dispatch])

    const expandBtnOptions = useMemo(() => ({
        type: 'default',
        icon: expanded ? 'minus' : 'add',
        disabled: true,
        elementAttr: { class: 'form__group__toolbar__expandbtn' }
    }), [expanded])

    const moveDownBtnOptions = useMemo(() => ({
        type: 'default',
        icon: index === orderMap.length - 1 ? 'empty' : 'chevrondown',
        elementAttr: { id: id, class: 'moving-btn' },
        onClick: (e: any) => { onMoveDown && onMoveDown(Number(e.element.id)) }
    }), [id, index, orderMap])

    const moveUpBtnOptions = useMemo(() => ({
        type: 'default',
        icon: !index ? 'empty' : 'chevronup',
        elementAttr: { id: id, class: 'moving-btn' },
        onClick: (e: any) => { onMoveUp && onMoveUp(Number(e.element.id)) }
    }), [id, index])

    const onClick = useCallback((__: any) => {
        if (formId) {
            setExpandedFormGroupsData('form-layout', formId, {...expandedFormGroups, [id]: !expanded}, expandedFormGroupsId, SettingType.GlobalSetting)
        }

        setExpanded(!expanded)

    },[expandedFormGroups, expanded, setExpandedFormGroupsData, expandedFormGroupsId, formId, id])


    const containerStyle: any = useMemo(() => {
        if (!expanded) {
            return { display: 'none' }
        } else {
            return {}
        }
    }, [expanded])

    return (
        <div className='form__group' style={{...style, order: index}}>
            <div onClick={onClick} style={{ cursor: 'pointer' }}>
                <Toolbar className={`form__group__toolbar ${caption ? '' : 'form__group__toolbar__caption--hidden'}`} >
                    <Item cssClass='form__group__toolbar__caption' location='before' text={name} />
                    <Item location='after' widget='dxButton' options={moveDownBtnOptions} />
                    <Item location='after' widget='dxButton' options={moveUpBtnOptions} />
                    <Item location='after' widget='dxButton' options={expandBtnOptions} />
                </Toolbar>
            </div>
            <div style={containerStyle}>
                {props.children}
            </div>
        </div>
    )
}
